export const FORM_EXIT = {duration: 0.18, ease: 'easeIn' as const};
export const SUMMARY_ENTER = {duration: 0.3, ease: [0.4, 0, 0.2, 1] as const};
